import styled from 'styled-components'
import { ReactComponent as CubeSvg } from '../../assets/images/cube.svg'

export const Cube = styled(CubeSvg)<{ size: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
`
